module.exports = "/assets/data/17e361d46af03199276d6efe12b3df97-KT13.data.json";